/**
 * L'evento speciale: una gara nata dal CALENDARIO.
 *
 * «Speciale» non e' una colonna: e' `created_by IS NULL`, cioe' l'assenza di un
 * umano dietro la gara. Una fascia di `schedule_slots` — l'arena del venerdi',
 * la coppa — materializza righe senza creatore; tutto il resto lo apre una
 * persona dal modale, e porta il suo nome. Il database contiene gia' la
 * distinzione: non serviva inventarne una seconda.
 */

/**
 * Quanti giorni prima si annuncia un evento speciale.
 *
 * Sette, ed e' il numero che tiene insieme tre cose che senza di lui
 * driftano:
 *
 * 1. la finestra della card sotto la hero (`FINESTRA_MS` in
 *    `EventoSpecialeCard.tsx`), cioe' da quando l'evento si vede;
 * 2. il tetto degli elenchi (`entroGiorni` nei due `findAll`), cioe' fino a
 *    dove il calendario riempie la pagina dei tornei;
 * 3. `GIORNI_DI_ANTICIPO` nello scheduler, che vale questo numero PIU' due di
 *    margine — una card non puo' annunciare una riga che non esiste, e il
 *    margine copre un server fermo per una mattina.
 *
 * Sette e non tre perche' un evento speciale e' raro per definizione: l'arena
 * ordinaria della settimana prossima e' mobilio, la coppa del mondo della
 * settimana prossima e' la ragione per cui uno torna.
 */
export const GIORNI_ANNUNCIO_EVENTO = 7;

/** La stessa finestra in millisecondi, per chi conta il tempo e non i giorni. */
export const FINESTRA_ANNUNCIO_EVENTO_MS = GIORNI_ANNUNCIO_EVENTO * 24 * 60 * 60_000;
